"use client";

import { globalErrorLanguage } from "@/components/error-page/global-error-language";
import texts from "@/components/error-page/global-error-texts.json";

const page = { margin: 0, minHeight: "100vh", display: "grid", placeItems: "center", fontFamily: "system-ui, sans-serif", colorScheme: "light dark", background: "Canvas", color: "CanvasText" } as const;
const box = { maxWidth: "28rem", padding: "1rem", display: "grid", gap: "0.75rem" } as const;

/** Last resort when the page frame itself fails: it has no providers or styles, so it brings its own plain look and texts. */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const lang = globalErrorLanguage(typeof window === "undefined" ? "/" : window.location.pathname);
  const t = texts[lang];
  return (
    <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"}>
      <body style={page}>
        <main style={box}>
          <h1>{t.title}</h1>
          <p>{t.text}</p>
          {error.digest && <p>{t.reference}: <code>{error.digest}</code></p>}
          <button onClick={reset} style={{ justifySelf: "end" }}>{t.tryAgain}</button>
        </main>
      </body>
    </html>
  );
}
